import 	BlockEdit from './slider-block-edit.jsx';

const { registerBlockType } = wp.blocks;
const { useBlockProps, RichText, InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, SelectControl } = wp.components;
const { __ } = wp.i18n;
const { withSelect, select } = wp.data;

const ALLOWED_MEDIA_TYPES = [ 'image' ];

registerBlockType(
	'som/info-bubi', {
	title:  __('SOM Info bubi', 'semmelweis_museum'),
	category: 'common',
	icon: 'info',
	description: __('Kiemelt, figyelem felhívó tartalom.', 'semmelweis_museum'),
	keywords: ['info', 'som'],
	attributes: {
		somInfoBody: {
			type: 'string',
			default: '',
			source: 'html',
			selector: 'span',
			attribute: 'som-info-text',
		},
		somInfoColor: {
			type: 'string',
			default: 'som-alert-info'
		},
		somInfoIcon: {
			type: 'string',
			default: 'info'
		},
	},
	
	edit: (props) => { 
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();
		return (
				<div { ...blockProps }>
					<InspectorControls>
						<PanelBody title="SOM Infó bubi" initialOpen={true}>
							<PanelRow>
								<SelectControl
									label="Választható háttér és a szöveg színek."
									value={attributes.somInfoColor}
									options={[
										{label: "Kék", value: 'som-alert-info'},
										{label: "Halvány piros", value: 'som-alert-error'},
										{label: "Sárga", value: 'som-alert-warning'},
										{label: "Zöld", value: 'som-alert-success'},
										{label: "Piros - fehér szöveg", value: 'som-alert-doom'},
									]}
									onChange={(newval) => setAttributes({ somInfoColor: newval })}
								/>
							</PanelRow>
							<PanelRow>
								<SelectControl
									label="Választható ikonok."
									value={attributes.somInfoIcon}
									options={[
										{label: "Infó", value: 'info'},
										{label: "Felkiáltó jel", value: 'exclamation'},
										{label: "Rajzszög", value: 'pin'},
										{label: "Óra", value: 'clock'},
									]}
									onChange={(newval) => setAttributes({ somInfoIcon: newval })}
								/>
							</PanelRow>
						</PanelBody>
					</InspectorControls>
					<div className="som-block-info">
						<RichText
							tagName="p"
							placeholder="Szöveg"
							value={attributes.somInfoBody}
							onChange={(newtext) => setAttributes({ somInfoBody: newtext })}
						/>
					</div>
				</div> 
			);
		
	},
	
	save: (props) => { 
		const { attributes } = props;
		const infoIcon = "#"+attributes.somInfoIcon;
		const somInfoClass = "my-2 alert alert-dismissible fade show " + attributes.somInfoColor;
 		const blockProps = useBlockProps.save();
		return (
			<div { ...blockProps }
				className={somInfoClass} role="alert" >
				<p className="som-small m-0">
					<svg width="30" height="30" viewBox="0 0 140 140" class="mx-2">
						<use href={infoIcon} />
					</svg>
			 		<RichText.Content
			 			tagName="span" 
			 			className="som-info-text"
			 			value={ attributes.somInfoBody } />	
				</p>
			</div>
		);
	}}
);


// THE SLIDER BLOCK
registerBlockType(
	'som/slider', {
	title:  __('Slider galéria', 'semmelweis_museum'),
	category: 'media',
	icon: 'slides',
	description: __('Galéria horizontálisan lapozható képekkel.', 'semmelweis_museum'),
	keywords: ['slider', 'gallery', 'som'],
	attributes: {
		images: {
			type: 'array',
			source: 'query',
			selector: '.carousel-item',
			default: [],
			query: {
					mediaId: {
						type: 'number',
						default: 0,
						source: 'attribute',
				        selector: 'img',
				        attribute: 'data-id',
					},
					mediaUrl: {
						type: 'string',
						default: '',
						source: 'attribute',
				        selector: 'img',
				        attribute: 'src',
					},
					mediaAlt: {
						type: 'string',
						default: '',
						source: 'attribute',
						selector: 'img',
						attribute: 'alt',
					},
					mediaCaption: {
						type: 'string',
						default: '',
						source: 'text',
						selector: 'h5',
						attribute: 'som-carousel-title',
					},
			},	
		},
	},
	
	edit: withSelect((select, props) => {
		const imageIDs = props.attributes.images.map( item => item.mediaId );
		return { media: imageIDs.length > 0 ? select('core').getMediaItems( { include: imageIDs } ) : undefined };
	})(BlockEdit),

	save: (props) => {

		const { attributes } = props;

		if ( attributes.images.length < 1 ) {
			return null;
		}

		return (
			<div { ...useBlockProps.save() }>
				<div id="carouselExampleControls" class="carousel slide my-4" data-bs-ride="carousel">
 		 			<div class="carousel-inner">
						{ attributes.images.map( (item, index) => (
						<div className={(index === 0) ? 'som-carousel-item carousel-item active' : 'som-carousel-item carousel-item'}>
							<img className="d-block w-100" src={item.mediaUrl} data-id={item.mediaId} alt={item.mediaAlt} />
							{ !!item.mediaCaption &&
								<div class="carousel-caption som-carousel-caption d-none d-lg-block">
						        	<h5 class="som-carousel-title px-3">{item.mediaCaption}</h5>
						    	</div>
							}
						</div>
						)) }
					</div>
						<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
						    <svg width="40" height="40" viewBox="0 0 67 67" class="som-white-svg float-end">
								<use href="#left-arrow-neg"/>
								<image href="" src="<?php echo $template_dir . '/images/navigation/fallback_arrow_right.png'; ?>" 
									class="som-arrow-icon m-auto d-block" width="40" height="40" />
							</svg>
						    <span class="visually-hidden">Previous</span>
						</button>
						<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
						    <svg width="40" height="40" viewBox="0 0 67 67" class="som-white-svg float-end">
								<use href="#right-arrow-neg"/>
								<image href="" src="<?php echo $template_dir . '/images/navigation/fallback_arrow_right.png'; ?>" 
									class="som-arrow-icon m-auto d-block" width="40" height="40" />
							</svg>
						    <span class="visually-hidden">Next</span>
						</button>
				</div>
			</div>
		);
	}}
);

